const defaultDatetimeAccessor = json =>
  json.features.map(feature => feature.properties.timestamp)

export default defaultDatetimeAccessor



// WEBPACK FOOTER //
// ./src/utility/defaultDatetimeAccessor.js